import { CompanyDiscount } from "components/company-discounts/company-discounts";
import { IRequestAction, progressEpic } from "./base-epic";
import { COMPANY_DISCOUNTS } from "constants/action-types";
import siteConfig from "site-config";

export const fetchCompanyDiscountsEpic = progressEpic<IRequestAction, CompanyDiscount[]>(
    COMPANY_DISCOUNTS.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
    {
        dataCustomizer: (response, action, store) => {
            store.companyDiscounts.columnSchema = response.columns;
            return action.payload.next
                ? (store.companyDiscounts.payload || []).concat(response.discounts)
                : response.discounts;
        },
        debounce: 500,
    },
);
